module.exports = __webpack_public_path__ + "assets/img/home-yjzx.d8c77c68.png";